import nextTick from "General/global-js/nextTick";
import "slick-carousel";

const readyStates = {
    loading: 0,
    interactive: 1,
    complete: 2
}

export default class SlickSliderComponent {

    /**
     * Default constructor
     * @param {string} selector Selector component the component
     * @param {string} innerSelector Inner selector of slick slider containers
     * @param {boolean} executeInit Execution indication of the initialization if the component, if's available
     */
    constructor(selector, sliderInnerSelector, executeInit) {
        executeInit = executeInit == undefined ? true : executeInit;
        this.defaultSliderSelector = selector;
        this.defaultSliderInnerSelector = sliderInnerSelector;

        if (document.querySelectorAll(selector) != null
            && document.querySelectorAll(selector).length > 0
            && executeInit) {
            this.initSliders();
        }
    }

    init() {

    }

    /**
     * Initializes the slick sliders.
     * @param {JQuery} $sliders Sliders to initialize
     * @param {string} sliderInnerSelector Inner selector of slick slider containers
     */
    initSliders($sliders, sliderInnerSelector) {
        const initFunction = () => {
            $sliders = $sliders || $(this.defaultSliderSelector);
            sliderInnerSelector = sliderInnerSelector || this.defaultSliderInnerSelector;

            $sliders.each(function () {
                var $this = $(this);
                var $slider = $this.find(sliderInnerSelector);
                var $dotsNavContainer = $this.find(".pagination-dots");
                var $prevArrow = $this.find(".pagination .pagination-prev");
                var $nextArrow = $this.find(".pagination .pagination-next");
                var dotsForTranslation = $dotsNavContainer.attr("data-dots-of-translation");

                // Get the slide elements before the slick slider is initialized
                // to check which pagination should be rendered
                // This class is needed for every container which contains the elements for the slider.
                var $slideElements = $this.find(sliderInnerSelector);

                if ($slideElements == null ||
                    $slideElements.length == 0 ||
                    $slideElements[0].childElementCount.length == 0) {
                    return;
                }

                // hack for fixing labels that always gets overriden
                var fixDotTranslation = function () {
                    if (!dotsForTranslation?.length) {
                        return;
                    }

                    nextTick(function () {
                        var slideCounter = 1;
                        var $dotsNavContainerButtons = $dotsNavContainer.find("button");
                        var slideCount = $dotsNavContainerButtons.length;
                        $dotsNavContainerButtons.find("button").each(function () {
                            var ariaLabel = slideCounter + " " + dotsForTranslation + " " + slideCount;
                            $(this).attr("aria-label", ariaLabel);
                            slideCounter++;
                        });
                    });
                };

                if (typeof $slider.attr("sc-part-of") != "undefined") {
                    return;
                }

                if ($slideElements[0].childElementCount > 3) {
                    var $status = $this.find(".pagingInfo");

                    $status.addClass("show");

                    /* eslint-disable no-unused-vars */
                    $slider.on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
                        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
                        var i = (currentSlide ? currentSlide : 0) + 1;
                        $status.text(i + " / " + slick.slideCount);
                    });
                    /* eslint-enable no-unused-vars */
                } else {
                    $slider.on("afterChange", function (slick) {
                        fixDotTranslation(slick);
                    });

                    $slider.on("init", function (slick) {
                        fixDotTranslation(slick);
                    });
                }

                $slider.not('.slick-initialized').slick({
                    speed: 0,
                    adaptiveHeight: true,
                    arrows: true,
                    dots: true,
                    appendDots: $dotsNavContainer,
                    prevArrow: $prevArrow,
                    nextArrow: $nextArrow,
                    dotsClass: $slideElements[0].childElementCount <= 3 ? "pagination-dots" : "hide",
                    lazyLoad: "progressive",
                });
            });
        };

        if (readyStates[document.readyState] < readyStates.interactive) {
            window.addEventListener("load", initFunction);
        } else {
            initFunction();
        }
    }

    /**
     * Disables the slick sliders.
     * @param {JQuery} $sliders Sliders to initialize
     * @param {string} sliderInnerSelector Inner selector of slick slider containers
     */
    disableSliders($sliders, sliderInnerSelector) {
        $sliders = $sliders || $(this.defaultSliderSelector);
        sliderInnerSelector = sliderInnerSelector || this.defaultSliderInnerSelector;

        $sliders.each(function () {
            var $this = $(this);
            var $slider = $this.find(sliderInnerSelector);

            if ($slider.slick) {
                try {
                    $slider.slick("unslick");
                }
                catch (err) {
                    console.warn(err);
                }
            }
        });
    }
}